import { TFunction } from "i18next";

export function mapInvoiceTypeToBadgeColor(invoiceType: string): string {
  switch (invoiceType) {
    case "F1":
    case "F3":
      return "green";
    case "F2":
      return "blue";
    default:
      return invoiceType.startsWith("R") ? "orange" : "gray";
  }
}

export function mapInvoiceTypeToText(
  t: TFunction,
  invoiceType: string,
): string {
  switch (invoiceType) {
    case "F1":
    case "F3":
      return t("taxInvoices.type.invoice");
    case "F2":
      return t("taxInvoices.type.receipt");
    default:
      return invoiceType.startsWith("R")
        ? t("taxInvoices.type.correction")
        : invoiceType;
  }
}

export function isSimplified(invoiceType: string): boolean {
  return invoiceType === "F2";
}
